import { dimensions } from '$tablet-app/src/app/theme';
import React, { FC, useRef } from 'react';
import styled from 'styled-components/native';
import { PopUp } from '../PopUp/PopUp';

interface Props {
  anchor: (params: { showPopUp: () => void }) => React.ReactNode;
  children: (params: { hidePopUp: () => void }) => React.ReactNode;
}

const PopUpMenu: FC<Props> = (props) => {
  const { anchor } = props;

  const ref = useRef<PopUp>();

  const setPopUpRef = (_ref: PopUp) => (ref.current = _ref);

  const hidePopUp = () => {
    ref.current?.hide();
  };

  const showPopUp = () => {
    ref.current?.show();
  };

  return (
    <StyledPopup
      ref={setPopUpRef}
      animationType="fade"
      transparent={true}
      anchor={anchor ? anchor({ showPopUp }) : null}
    >
      {props.children({ hidePopUp })}
    </StyledPopup>
  );
};

const StyledPopup = styled(PopUp)`
  padding: 0px;
  border-radius: ${dimensions.buttonRadius}px;
  border-width: 0;
  elevation: 2;
`;

export default PopUpMenu;
